module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module1-1.bda8f89f.png";